<!-- Hidden file input field -->
<input #uploadInput type="file" class="d-none file-input" id="documentUpload" (change)="onFileSelected($event)" [multiple]="acceptMultipleFiles" [accept]="fileTypes">

<!-- Shown upload button -->
<button type="button" class="btn btn-primary" (click)="uploadInput.click()">Upload</button>
